


















import Vue from 'vue';
import { Loader } from 'mycorems-app-shared';
import { Account } from '@/types';
import accountRepository from './account-repository';
import AccountDetailsBar from './AccountDetailsBar.vue';

interface Data {
  task: Promise<Account>|null,
  account: Account|null,
}

export default Vue.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
    parentId: String,
    static: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      task: null,
      account: null,
    };
  },
  watch: {
    accountId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load(): void {
      this.task = accountRepository.find(this.accountId);
      this.task.then((account: Account) => {
        this.account = account;
      });
    },
  },
  components: {
    loader: Loader,
    'account-details-bar': AccountDetailsBar,
  },
});
